var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPets(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0023 9.75023C14.0023 10.1646 14.3382 10.5005 14.7526 10.5005V10.5005C15.5814 10.5005 16.2532 9.82869 16.2532 8.99992V6.74898C16.2532 5.50583 15.2455 4.49805 14.0023 4.49805H13.6895",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53681 13.3862L5.74805 15.7525",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4629 13.3862L13.2516 15.7525",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.30991 4.49805H4.99703C3.75387 4.49805 2.74609 5.50583 2.74609 6.74898V8.99992C2.74609 9.82869 3.41795 10.5005 4.24672 10.5005V10.5005C4.6611 10.5005 4.99703 10.1646 4.99703 9.75023",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0012 13.3733V13.8767C11.0012 14.4983 10.4974 15.0022 9.87578 15.0022H9.12547C8.50389 15.0022 8 14.4983 8 13.8767V13.373",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.49992 10.2504V11.2508C9.49992 12.494 8.49214 13.5018 7.24898 13.5018V13.5018C6.00583 13.5018 4.99805 12.494 4.99805 11.2508V5.99863C4.99805 3.9267 6.67768 2.24707 8.74961 2.24707H10.2502C12.3222 2.24707 14.0018 3.9267 14.0018 5.99863V11.2508C14.0018 12.494 12.994 13.5018 11.7509 13.5018V13.5018C10.5077 13.5018 9.49992 12.494 9.49992 11.2508V10.2504Z",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1877 7.12442C11.1876 7.22795 11.1036 7.3118 11.0001 7.31176C10.8965 7.31171 10.8126 7.22779 10.8126 7.12426C10.8125 7.02073 10.8964 6.93673 10.9999 6.9366C11.0497 6.93654 11.0976 6.95631 11.1328 6.99154C11.168 7.02678 11.1878 7.07459 11.1877 7.12442",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18773 7.12442C8.1876 7.22795 8.10361 7.3118 8.00008 7.31176C7.89654 7.31171 7.81262 7.22779 7.81258 7.12426C7.81253 7.02073 7.89638 6.93673 7.99992 6.9366C8.04975 6.93654 8.09756 6.95631 8.13279 6.99154C8.16803 7.02678 8.1878 7.07459 8.18773 7.12442",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPets);
export default __webpack_public_path__ + "static/media/pets.229e80c465fb2628d27ed8e422df8d8d.svg";
export { ForwardRef as ReactComponent };